import useCoreConfig from '@/hooks/use-core-config';
import type { SystemConfig } from '@/types/system-config';

const useSystemConfig = (): SystemConfig => {
  const { systemConfig } = useCoreConfig();
  return systemConfig ?? {};
};

export default useSystemConfig;
